import React from 'react'
import PropTypes from 'prop-types'

import { COLORS } from '@elo-kit/constants/general.constants'

const { eloGreen, eloRed, eloOrange, eloBlue, eloGrey50 } = COLORS

export const STATUSES = Object.freeze({
  completed: 'completed',
  waiting: 'waiting',
  failed: 'failed',
  in_progress: 'in_progress',
  retrying: 'retrying',
  skipped: 'skipped',
})

const iconProps = Object.freeze({
  [STATUSES.completed]: {
    className: 'fas fa-check-circle',
    color: eloGreen,
  },
  [STATUSES.waiting]: {
    className: 'fas fa-question-circle',
    color: eloOrange,
  },
  [STATUSES.failed]: {
    className: 'fas fa-times-circle',
    color: eloRed,
  },
  [STATUSES.in_progress]: {
    className: 'fas fa-spinner',
    color: '#9e9e9e',
  },
  [STATUSES.retrying]: {
    className: 'fas fa-redo',
    color: eloBlue,
  },
  [STATUSES.skipped]: {
    className: 'fas fa-minus-circle',
    color: eloGrey50,
  },
})

const QuizStatus = ({ type, children, className }) => (
  <i style={{ color: iconProps[type].color }} className={`${iconProps[type].className} ${className}`}>
    <span className='block--font-gotham'> {children}</span>
  </i>
)

QuizStatus.propTypes = {
  type: PropTypes.oneOf(Object.values(STATUSES)).isRequired,
  children: PropTypes.string,
  className: PropTypes.string,
}

QuizStatus.displayName = 'QuizStatus'

export default React.memo(QuizStatus)
